import Slideout from 'slideout';

export default class Header {

	constructor () {
		this.init();
	}

	init () {
		this.initLanguageSwitcher();
		this.initSlideout();
		this.initMobileMenu();
		this.initFixedHeader();
	}

	initLanguageSwitcher () {
		let link = document.querySelector('.language-switcher a');
		let parameters = window.location.search.substr(1);
		if (parameters) {
			link.href = link.href + '?' + parameters;
		}
	}

	initSlideout () {
		let toggleButton = document.createElement('button');
		toggleButton.classList.add('toggle-button');
		document.querySelector('.main-nav').appendChild(toggleButton);

		let mainPanel = document.getElementById('main-panel');

		let slideout = new Slideout({
			'panel': document.getElementById('main-panel'),
			'menu': document.getElementById('mobile-menu'),
			'padding': 320,
			'tolerance': 70,
			'side': 'right'
		});

		toggleButton.addEventListener('click', function () {
			slideout.toggle();
		});

		let closeButton = document.createElement('button');
		closeButton.classList.add('close-button');
		document.querySelector('#mobile-menu').appendChild(closeButton);

		closeButton.addEventListener('click', function () {
			slideout.toggle();
		});

		let fixed = document.querySelector('.main-nav');

		slideout.on('translate', function (translated) {
			fixed.style.transform = 'translateX(' + translated + 'px)';
		});

		slideout.on('beforeopen', function () {
			fixed.style.transition = 'transform 300ms ease';
			fixed.style.transform = 'translateX(-320px)';
			mainPanel.classList.add('slideout-active');
		});

		slideout.on('beforeclose', function () {
			fixed.style.transition = 'transform 300ms ease';
			fixed.style.transform = 'translateX(0px)';
			mainPanel.classList.remove('slideout-active');
		});

		slideout.on('open', function () {
			fixed.style.transition = '';
		});

		slideout.on('close', function () {
			fixed.style.transition = '';
		});
	}

	initMobileMenu () {
		let mobileMenu = document.querySelector('#mobile-menu');

		mobileMenu.appendChild(document.querySelector('.main-nav nav.primary').cloneNode(true));
		mobileMenu.appendChild(document.querySelector('.main-nav nav.contact').cloneNode(true));
		mobileMenu.appendChild(document.querySelector('.main-nav nav.secondary').cloneNode(true));
		mobileMenu.appendChild(document.querySelector('.main-nav .language-switcher').cloneNode(true));

		mobileMenu.appendChild(document.querySelector('.footer-nav').cloneNode(true));
	}

	initFixedHeader () {
		let header = document.querySelector('.main-nav');
		let logo = document.querySelector('.main-nav .logo');

		checkSticky();
		window.onscroll = function () {checkSticky();};

		function checkSticky () {
			if (document.body.classList.contains('projects')) {
				let logoUrl = logo.getAttribute('data-logo-sticky');
				logo.style.backgroundImage = 'url(' + logoUrl + ')';
				header.classList.add('sticky');

			} else {
				if (window.pageYOffset > 0) {
					let logoUrl = logo.getAttribute('data-logo-sticky');
					logo.style.backgroundImage = 'url(' + logoUrl + ')';
					header.classList.add('sticky');

				} else {
					let logoUrl = logo.getAttribute('data-logo');
					logo.style.backgroundImage = 'url(' + logoUrl + ')';
					header.classList.remove('sticky');
				}
			}
		}
	}
}
